import { defineMessages } from 'react-intl';

const messages = defineMessages({
  emailContent: { id: 'src-modules-default-survey-thank-you-page-email-content' },
  emailSubject: { id: 'src-modules-default-survey-thank-you-page-email-subject' },
});

export default messages;
